import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersThree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayersThree"><Path d="M21.8848 12.0001L11.9971 17.0937L2.10938 12.0001L3.74677 11.1566L11.9971 15.4064L20.2468 11.1562L21.8848 12.0001Z" fill="currentColor"/><Path d="M21.8848 16.0001L11.9971 21.0937L2.10938 16.0001L3.74677 15.1566L11.9971 19.4064L20.2468 15.1562L21.8848 16.0001Z" fill="currentColor"/><Path d="M11.999 2.90625L2.11133 7.99992L11.999 13.0936L21.8867 7.99992L11.999 2.90625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersThree;
